export type CategoryType = {
    id: number;
    name: string;
    image: string;
    slug: string;
};

export const categories: CategoryType[] = [
    {
        id: 1,
        name: "Armpynt",
        image: "/klassiske-armband-1_5x4.png",
        slug: "armband"
    },
    {
        id: 2,
        name: "Ørepynt",
        image: "/klassisk-orepynt-1_5x4.png",
        slug: "orepynt"
    },
    {
        id: 3,
        name: "Mobilpynt",
        image: "/mobilpynt-1_5x4.png",
        slug: "mobilpynt"
    }
];
